<div class="modal-container">
  <!-- Modal Header -->
  <div
    class="modal-header bg-primary text-white d-flex justify-content-between align-items-center"
  >
    <h5 class="modal-title m-0 text-white">Reminder</h5>
    <button type="button" class="close text-white" (click)="close()">×</button>
  </div>

  <!-- Modal Body -->
  <div class="modal-body p-2">
    <!-- Reminder Details -->
    <div class="reminder-details mb-3">
      <!-- Title -->
      <div class="detail-item mb-2">
        <label class="detail-label">Title:</label>
        <div class="detail-value">{{ data.title }}</div>
      </div>

      <!-- Description -->
      <div class="detail-item mb-2">
        <label class="detail-label">Description:</label>
        <div class="detail-value text-secondary">{{ data.description }}</div>
      </div>

      <!-- Due Date -->
      <div
        class="detail-item mb-2 d-flex justify-content-between align-items-center"
      >
        <label class="detail-label mb-0">Due Date:</label>
        <div class="detail-value">{{ data.dueDate | date : "mediumDate" }}</div>
      </div>

      <!-- Priority -->
      <div
        class="detail-item d-flex justify-content-between align-items-center"
      >
        <label class="detail-label mb-0">Priority:</label>
        <span
          class="badge priority-badge"
          [ngClass]="getPriorityBadgeClass(+data.priority)"
        >
          {{ priorityLabel }}
        </span>
      </div>
    </div>

    <!-- Date/Time Picker Section -->
    <div *ngIf="showDateTimePicker" class="date-time-picker mb-3">
      <h6 class="mb-2">Select when to remind:</h6>
      
      <!-- Quick Options -->
      <div class="quick-options mb-3">
        <div class="row g-2">
          <div *ngFor="let option of quickOptions" class="col-6">
            <button 
              type="button" 
              class="btn btn-outline-secondary btn-sm w-100"
              (click)="selectQuickOption(option)"
            >
              {{ option.label }}
            </button>
          </div>
        </div>
      </div>

      <!-- Manual Date/Time Selection -->
      <div class="row g-2">
        <div class="col-md-6">
          <label class="form-label">Date</label>
          <input 
            type="date" 
            class="form-control form-control-sm" 
            [(ngModel)]="selectedDate"
            [min]="minDate"
          >
        </div>
        <div class="col-md-6">
          <label class="form-label">Time</label>
          <input 
            type="time" 
            class="form-control form-control-sm" 
            [(ngModel)]="selectedTime"
          >
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="modal-actions d-flex gap-2">
      <button 
        class="btn btn-success flex-fill mr-1" 
        (click)="markAsDone()"
        [disabled]="isMarkingAsDone || !currentUserId"
      >
        <span *ngIf="!isMarkingAsDone">Mark as Done</span>
        <span *ngIf="isMarkingAsDone">
          <i class="fas fa-spinner fa-spin"></i> Processing...
        </span>
      </button>
      <button 
        class="btn btn-primary flex-fill" 
        (click)="showDateTimePicker ? remindMeLater() : toggleDateTimePicker()"
        [disabled]="isSettingReminder || isMarkingAsDone"
      >
        <span *ngIf="!isSettingReminder">
          {{ showDateTimePicker ? 'Set Reminder' : 'Remind Me Later' }}
        </span>
        <span *ngIf="isSettingReminder">
          <i class="fas fa-spinner fa-spin"></i> Setting...
        </span>
      </button>
    </div>

    <!-- Toggle Date/Time Picker Button -->
    <div *ngIf="showDateTimePicker" class="text-center mt-2">
      <button 
        type="button" 
        class="btn btn-link btn-sm text-muted"
        (click)="toggleDateTimePicker()"
      >
        Cancel
      </button>
    </div>
  </div>
</div>